import React from "react";

const Pagination = ({ totalItems, currentPage, pageSize, onPageChange }) => {
  if (totalItems <= pageSize) return null;

  const lastPage = Math.ceil(totalItems / pageSize);
  const start =
    currentPage === lastPage
      ? Math.max(currentPage - 2, 1)
      : currentPage > 1
      ? currentPage - 1
      : currentPage;

  const pages = [];
  for (let i = 0; i < 3; i++) if (start + i <= lastPage) pages.push(start + i);

  return (
    <div className="pager">
      <button className="pager-btn" disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)} aria-label="Previous">‹</button>
      {pages.map((p) => (
        <button key={p} className={`pager-btn ${p === currentPage ? "on" : ""}`} onClick={() => onPageChange(p)}>{p}</button>
      ))}
      <button className="pager-btn" disabled={currentPage === lastPage} onClick={() => onPageChange(currentPage + 1)} aria-label="Next">›</button>
    </div>
  );
};

export default Pagination;
